<template>
  <div class="header">
    <div class="header__info">
      <img
        src="@/assets/Images/Global/Logo.svg"
        alt=""
        class="header__info__logo"
      />
      <div class="header__info__separator"></div>
      <p class="header__info__collection">
        {{ Coleccion.GetLiteral(Language) }}
      </p>
    </div>
    <div class="header__menu">
      <div class="header__menu__option">
        <div
          class="header__menu__option__items"
          :class="{
            hidden: !Open,
          }"
        >
          <div
            v-for="(Option, OptionIndex) in Options"
            :key="OptionIndex"
            class="header__menu__option__items__item"
          >
            <div
              v-if="Option.cod == 'Share'"
              @click="SetOption($event, Option)"
              class="header__menu__option__items__item__option"
            >
              <img
                @load="ResolveImage($event)"
                :src="require('@/assets/Images/' + Option.miniatura)"
                alt=""
                class="header__menu__option__items__item__option__image"
              />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[
                      Option.literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div
              v-else-if="Option.cod == 'DarkMode'"
              @click="SetOption($event, Option)"
              class="header__menu__option__items__item__option"
            >
              <img
                @load="ResolveImage($event)"
                :src="
                  require('@/assets/Images/' +
                    Option.miniatura[DarkMode == true ? 1 : 0])
                "
                alt=""
                class="header__menu__option__items__item__option__image"
              />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[DarkMode == true ? 1 : 0].literales[
                      Option.literales[
                        DarkMode == true ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div
              v-else-if="Option.cod == 'Hotspots'"
              @click="SetOption($event, Option)"
              class="header__menu__option__items__item__option"
            >
              <img
                @load="ResolveImage($event)"
                :src="
                  require('@/assets/Images/' +
                    Option.miniatura[Hotspots == true ? 1 : 0])
                "
                alt=""
                class="header__menu__option__items__item__option__image"
              />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[Hotspots == true ? 1 : 0].literales[
                      Option.literales[
                        Hotspots == true ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div
              v-else-if="Option.cod == 'Zoom'"
              @click="SetOption($event, Option)"
              class="header__menu__option__items__item__option"
            >
              <img
                @load="ResolveImage($event)"
                :src="
                  require('@/assets/Images/' +
                    Option.miniatura[Zoom == true ? 1 : 0])
                "
                alt=""
                class="header__menu__option__items__item__option__image"
              />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[Zoom == true ? 1 : 0].literales[
                      Option.literales[
                        Zoom == true ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div
              v-else-if="Option.cod == 'FullScreen'"
              @click="SetOption($event, Option)"
              class="header__menu__option__items__item__option"
            >
              <img
                @load="ResolveImage($event)"
                :src="
                  require('@/assets/Images/' +
                    Option.miniatura[FullScreen == true ? 1 : 0])
                "
                alt=""
                class="header__menu__option__items__item__option__image"
              />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[FullScreen == true ? 1 : 0].literales[
                      Option.literales[
                        FullScreen == true ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div class="header__menu__option__items__item__separator"></div>
          </div>
        </div>
        <div
          @click="Open = !Open"
          class="header__menu__option__icon hamburguer"
          :class="{
            open: Open,
          }"
        >
          <div class="header__menu__option__icon__bar"></div>
          <div class="header__menu__option__icon__bar"></div>
          <div class="header__menu__option__icon__bar"></div>
        </div>
      </div>
      <div class="header__menu__separator"></div>
      <img
        @click="$emit('Close')"
        src="@/assets/Images/Global/Home.svg"
        alt=""
        class="header__menu__option__icon"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    Language: String,
    Coleccion: Object,
    Options: Array,
    DarkMode: Boolean,
    Hotspots: Boolean,
    Zoom: Boolean,
    FullScreen: Boolean,
  },
  data() {
    return {
      Open: false,
    };
  },
  methods: {
    ResolveImage(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      element.style.opacity = 1;
    },
    SetOption(e, Object) {
      switch (Object.cod) {
        case "Share":
          this.$emit("Share");
          break;
        case "DarkMode":
          this.$emit("DarkMode", !this.DarkMode);
          break;
        case "Hotspots":
          this.$emit("Hotspots", !this.Hotspots);
          break;
        case "Zoom":
          this.$emit("Zoom", !this.Zoom);
          break;
        case "FullScreen":
          this.$emit("FullScreen", !this.FullScreen);
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  height: $Header-height;
  padding: 0px 25px;
  background-color: white;
  -webkit-transition: background-color 0.35s ease-in-out;
  -moz-transition: background-color 0.35s ease-in-out;
  -ms-transition: background-color 0.35s ease-in-out;
  -o-transition: background-color 0.35s ease-in-out;
  transition: background-color 0.35s ease-in-out;
  &__info {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    height: 100%;
    &__logo {
      filter: invert(0%) brightness(100%);
      height: 30px;
      -webkit-transition: filter 0.35s ease-in-out;
      -moz-transition: filter 0.35s ease-in-out;
      -ms-transition: filter 0.35s ease-in-out;
      -o-transition: filter 0.35s ease-in-out;
      transition: filter 0.35s ease-in-out;
    }
    &__collection {
      color: black;
      font-size: 25px;
      font-weight: 500;
      text-transform: capitalize;
      -webkit-transition: color 0.35s ease-in-out;
      -moz-transition: color 0.35s ease-in-out;
      -ms-transition: color 0.35s ease-in-out;
      -o-transition: color 0.35s ease-in-out;
      transition: color 0.35s ease-in-out;
    }
    &__separator {
      pointer-events: none;
      height: 40%;
      width: 0.1em;
      background-color: black;
      margin: 0px 15px;
      -webkit-transition: background-color 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out;
    }
  }
  &__menu {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    height: 100%;
    &__option {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      align-content: center;
      height: 100%;
      &__items {
        opacity: 1;
        position: absolute;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        right: 60px;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
        &__item {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          align-content: center;
          height: 100%;
          &__option {
            position: relative;
            &__image {
              filter: invert(0%);
              opacity: 1;
              cursor: pointer;
              width: 24px;
              height: 24px;
              object-fit: cover;
              -webkit-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            }
            &__name {
              filter: invert(0%);
              opacity: 0;
              pointer-events: none;
              position: absolute;
              right: 0px;
              top: 30px;
              white-space: nowrap;
              background-color: black;
              color: white;
              font-size: 10px;
              padding: 4px 14px;
              -webkit-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              & p {
                opacity: 1;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }
            &:hover {
              & .header__menu__option__items__item__option {
                &__name {
                  opacity: 1;
                  -webkit-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                }
              }
            }
          }
          &__separator {
            opacity: 0;
            pointer-events: none;
            height: 40%;
            width: 0.1em;
            background-color: black;
            margin: 0px 10px;
          }
          &:last-child {
            & .header__menu__option__items__item {
              &__separator {
                display: none;
              }
            }
          }
        }
        &.hidden {
          opacity: 0;
          pointer-events: none;
          right: -190px;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
        }
      }
      &__icon {
        filter: invert(0%);
        cursor: pointer;
        width: 24px;
        height: 24px;
        object-fit: cover;
        -webkit-transition: filter 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out;
        &__bar {
          transform: none;
          width: 85%;
          height: 0.1em;
          background-color: black;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
        }
        &.hamburguer {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: center;
          align-content: center;
          height: 45%;
        }
        &.open {
          & .header__menu__option__icon__bar {
            &:nth-child(1) {
              transform: translate(0, 6px) rotate(-45deg);
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }
            &:nth-child(2) {
              opacity: 0;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }
            &:nth-child(3) {
              transform: translate(0, -6px) rotate(45deg);
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }
          }
        }
      }
    }
    &__separator {
      pointer-events: none;
      height: 40%;
      width: 0.1em;
      background-color: black;
      margin: 0px 12px;
      -webkit-transition: background-color 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out;
    }
  }
}
</style>
